/**
 * @author lifei & gll
 * 模块说明：xxx
 */

import { Service } from '@/tools'
export class TransferService<T extends TStock.Transfer> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.Transfer}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：分页查询转移单列表
   */
  page = (data: T['ApiPage']['req']): Promise<T['ApiPage']['res']> => this.post2('v1/ApiPage', data)

  /**
   * 功能：查询部门下业务组信息列表
   */
  getPurchaseGroupList = (data: T['ApiGetPurchaseGroupList']['req']): Promise<T['ApiGetPurchaseGroupList']['res']> =>
    this.post2('v1/ApiGetPurchaseGroupList', data)

  /**
   * 功能：获取公司下部门信息列表
   */
  getDeptInfoList = (data: T['ApiGetDeptInfoList']['req']): Promise<T['ApiGetDeptInfoList']['res']> => this.post2('v1/ApiGetDeptInfoList', data)

  /**
   * 功能：转移单编辑
   */
  edit = (data: T['ApiEdit']['req']): Promise<T['ApiEdit']['res']> => this.post2('v1/ApiEdit', data)

  /**
   * 功能：转移单详情
   */
  detail = (data: T['ApiDetail']['req']): Promise<T['ApiDetail']['res']> => this.post2('v1/ApiDetail', data)

  /**
   * 功能：转移单删除
   */
  deleteById = (data: T['ApiDeleteById']['req']): Promise<T['ApiDeleteById']['res']> => this.post2('v1/ApiDeleteById', data)

  /**
   * 功能：提交转移单
   */
  audit = (data: T['ApiAudit']['req']): Promise<T['ApiAudit']['res']> => this.post2('v1/ApiAudit', data)

  /**
   * 功能：转移单新增
   */
  add = (data: T['ApiAdd']['req']): Promise<T['ApiAdd']['res']> => this.post2('v1/ApiAdd', data)

  /**
   * 功能：转移单新增并提交
   */
  auditByAdd = (data: T['ApiAuditByAdd']['req']): Promise<T['ApiAuditByAdd']['res']> => this.post2('v1/ApiAuditByAdd', data)

  /**
   * 功能：外部转移单新增并提交
   */
  externalAdd = (data: T['ApiExternalAdd']['req']): Promise<T['ApiExternalAdd']['res']> => this.post2('v1/ApiExternalAdd', data)
}
